
import Vue from 'vue';

export default Vue.extend({
  name: 'CButton',
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  data(): { loading: boolean } {
    return { loading: false };
  },
  methods: {
    /**
     * function to be executed when button clicked, which decides the next step based on type of button
     */
    onButtonClick() {
      if (this.input.buttonType === 'print') {
        window.print(); 
      } else {
        this.parent._callMultipleFunctions(this.input.onClick);
      }
    }
  }
});
